export enum EnumConceptType {
  Employee = 0,
  Pay = 1,
  Variable = 2
}
